import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { ImageFile } from "../../../types/main-types/mainTypes";

interface ImagePreviewProps {
  imageList: ImageFile[];
  handleClose: (imageFile: ImageFile) => void;
}

function ImagePreview({ imageList, handleClose }: ImagePreviewProps) {
  //   const slideImages = [
  //     {
  //       url: "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
  //       caption: "Slide 1",
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80",
  //       caption: "Slide 2",
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
  //       caption: "Slide 3",
  //     },
  //   ];
  return (
    <div className="d-flex align-items-center justify-content-start flex-wrap gap-3">
      {imageList.map((img, index) => (
        <div key={index} className="position-relative">
          <div
            className="position-absolute bg-white end-0 opacity-75 top-minus-5 cursor-pointer"
            onClick={() => handleClose(img)}
          >
            <AiFillCloseCircle size={18} color="black" />
          </div>
          <img
            src={img.Url}
            alt=""
            className="width-100 height-100"
            onLoad={() => {
              URL.revokeObjectURL(img.Url);
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default ImagePreview;
